/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import Attributes from "./Attributes";
import Monster from "./Monster";

class Abilities {
    static base_actions: Ability[] = [
		{
			label: "Melee Weapon Attack (STR)",
			name: "Melee Weapon Attack",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach ??? ft., one target. *Hit:* [STR ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Weapon Attack (DEX)",
			name: "Melee Weapon Attack",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach ??? ft., one target. *Hit:* [DEX ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Spell Attack (INT)",
			name: "Melee Spell Attack",
			attribute: 'Intelligence',
			desc: "*Melee Spell Attack:* [INT ATK] to hit, reach ??? ft., one target. *Hit:* [INT ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Spell Attack (WIS)",
			name: "Melee Spell Attack",
			attribute: 'Wisdom',
			desc: "*Melee Spell Attack:* [WIS ATK] to hit, reach ??? ft., one target. *Hit:* [WIS ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Spell Attack (CHA)",
			name: "Melee Spell Attack",
			attribute: 'Charisma',
			desc: "*Melee Spell Attack:* [CHA ATK] to hit, reach ??? ft., one target. *Hit:* [CHA ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Weapon Attack (STR)",
			name: "Ranged Weapon Attack",
			attribute: 'Strength',
			desc: "*Ranged Weapon Attack:* [STR ATK] to hit, range ???/??? ft., one target. *Hit:* [STR ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Weapon Attack (DEX)",
			name: "Ranged Weapon Attack",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range ???/??? ft., one target. *Hit:* [DEX ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Spell Attack (INT)",
			name: "Ranged Spell Attack",
			attribute: 'Intelligence',
			desc: "*Ranged Spell Attack:* [INT ATK] to hit, range ???/??? ft., one target. *Hit:* [INT ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Spell Attack (WIS)",
			name: "Ranged Spell Attack",
			attribute: 'Wisdom',
			desc: "*Ranged Spell Attack:* [WIS ATK] to hit, range ???/??? ft., one target. *Hit:* [WIS ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Spell Attack (CHA)",
			name: "Ranged Spell Attack",
			attribute: 'Charisma',
			desc: "*Ranged Spell Attack:* [CHA ATK] to hit, range ???/??? ft., one target. *Hit:* [CHA ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee or Ranged Weapon Attack (STR)",
			name: "Melee or Ranged Weapon Attack",
			attribute: 'Strength',
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach ??? ft. or range ???/??? ft., one target. *Hit:* [STR ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee or Ranged Weapon Attack (DEX)",
			name: "Melee or Ranged Weapon Attack",
			attribute: 'Dexterity',
			desc: "*Melee or Ranged Weapon Attack:* [DEX ATK] to hit, reach ??? ft. or range ???/??? ft., one target. *Hit:* [DEX ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Bite (STR)",
			name: "Bite",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR ???d???] piercing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Bite (DEX)",
			name: "Bite",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX ???d???] piercing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Claw (STR)",
			name: "Claw",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR ???d???] slashing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Claw (DEX)",
			name: "Claw",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX ???d???] slashing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Tail",
			name: "Tail",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach ??? ft., one target. *Hit:* [STR ???d???] bludgeoning damage.",
			group: "Natural Attacks"
		},		
		{
			label: "Breath Weapon (Cone)",
			name: "Breath Weapon (Recharge ???)",
			desc: "The [MON] exhales ??? in a ???-foot cone. Each creature in that area must make a DC ??? Dexterity saving throw, taking [???d???] ??? damage on a failed save, or half as much damage on a successful one.",
			group: "Natural Attacks"
		},
		{
			label: "Breath Weapon (Line)",
			name: "Breath Weapon (Recharge ???)",
			desc: "The [MON] exhales ??? in a ???-foot line that is ??? feet wide. Each creature in that line must make a DC ??? Dexterity saving throw, taking [???d???] ??? damage on a failed save, or half as much damage on a successful one.",
			group: "Natural Attacks"
		},
		{
			name: "Constrict",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one creature. *Hit:* [STR ???d???] bludgeoning damage, and the target is grappled (escape DC ???). Until this grapple ends, the creature is restrained, and the [MON] can't constrict another target.",
			group: "Natural Attacks"
		},
		{
			name: "Life Drain",
			desc: "*Melee Spell Attack:*+??? to hit, reach ??? ft., one creature. *Hit:* [???d??? + ???] necrotic damage. The target must succeed on a DC ??? Constitution saving throw or its hit point maximum is reduced by an amount equal to the damage taken. This reduction lasts until the creature finishes a long rest. The target dies if this effect reduces its hit point maximum to 0.",
			group: "Natural Attacks"
		},
		{
			name: "Unarmed Strike",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1] bludgeoning damage.",
			group: "Natural Attacks"
		},
		{
			name: "Multiattack",
			desc: "The [MON] makes two attacks.",
			group: "Natural Attacks"
		},
		{
			name: "Change Shape",
			desc: "The [MON] magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the [MON]'s choice).\nIn a new form, the [MON] retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
			group: "Natural Abilities"
		},
		{
			label: "Change Shape (Humanoid)",
			name: "Change Shape",
			desc: "The [MON] magically polymorphs into a small or medium humanoid, or back into its true form. Its statistics are the same in each form. Any equipment the [MON] is wearing or carrying isn't transformed. If the [MON] dies, it reverts to its true form.",
			group: "Natural Abilities"
		},
		{
			name: "Etherealness",
			desc: "The [MON] magically enters the Ethereal Plane from the Material Plane, or vice versa.",
			group: "Natural Abilities"
		},
		{
			name: "Frightful Presence",
			desc: "Each creature of the [MON]'s choice that is within 120 feet of the [MON] and aware of it must succeed on a DC ??? Wisdom saving throw or become frightened for 1 minute. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. If a creature's saving throw is successful or the effect ends for it, the creature is immune to the [MON]'s Frightful Presence for the next 24 hours.",
			group: "Natural Abilities"
		},
		{
			label: "Healing Touch",
			name: "Healing Touch (???/day)",
			desc: "The [MON] touches another creature. The target magically regains [???d??? + ???] hit points and is freed from any curse, disease, poison, blindness, or deafness.",
			group: "Natural Abilities"
		},
		{
			name: "Illusory Appearance",
			desc: "The [MON] covers itself and anything it is wearing or carrying with a magical illusion that makes it look like another creature of its general size and shape. The effect ends if the [MON] takes a bonus action to end it or if it dies.\nThe changes wrought by this effect fail to hold up to physical inspection. For example, the [MON] could appear to have no claws, but someone touching its hand might feel the claws. Otherwise, a creature must take an action to visually inspect the illusion and succeed on a DC ??? Intelligence (Investigation) check to discern that the [MON] is disguised.",
			group: "Natural Abilities"
		},
		{
			label: "Innate Spellcasting (Single Spell)",
			name: "Innate Spellcasting (???/day)",
			desc: "The [MON] can innately cast ??? (spell save DC ???), requiring no material components. Its innate spellcasting ability is ???.",
			group: "Natural Abilities"
		},
		{
			name: "Invisibility",
			desc: "The [MON] magically turns invisible until it attacks or casts a spell, or until its concentration ends (as if concentrating on a spell). Any equipment the [MON] wears or carries is invisible with it.",
			group: "Natural Abilities"
		},
		{
			label: "Leadership",
			name: "Leadership (Recharges after a Short or Long Rest)",
			desc: "For 1 minute, the [MON] can utter a special command or warning whenever a nonhostile creature that it can see within 30 ft. of it makes an attack roll or a saving throw. The creature can add a d4 to its roll provided it can hear and understand the [MON]. A creature can benefit from only one Leadership die at a time. This effect ends if the [MON] is incapacitated.",
			group: "Natural Abilities"
		},
		{
			name: "Read Thoughts",
			desc: "The [MON] magically reads the surface thoughts of one creature within ??? ft. of it. The effect can penetrate barriers, but 3 ft. of wood or dirt, 2 ft. of stone, 2 inches of metal, or a thin sheet of lead blocks it. While the target is in range, the [MON] can continue reading its thoughts, as long as the [MON]'s concentration isn't broken (as if concentrating on a spell). While reading the target's mind, the [MON] has advantage on Wisdom (Insight) and Charisma (Deception, Intimidation, and Persuasion) checks against the target.",
			group: "Natural Abilities"
		},
		{
			name: "Shapechanger",
			desc: "The [MON] can use its action to polymorph into a ???, or back into its true form. Its statistics, other than its size, are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies.",
			group: "Natural Abilities"
		},
		{
			label: "Shapechanger (Lycanthrope)",
			name: "Shapechanger",
			desc: "The [MON] can use its action to polymorph into a ???-humanoid hybrid or into a ???, or back into its true form, which is humanoid. Its statistics, other than its AC, are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies.",
			group: "Natural Abilities"
		},
		{
			name: "Teleport",
			desc: "The [MON] magically teleports, along with any equipment it is wearing or carrying, up to 120 feet to an unoccupied space it can see.",
			group: "Natural Abilities"
		}
	];
	static traits = [
		{
			label: "Legendary Resistance",
			name: "Legendary Resistance (3/day)",
			desc: "If the [MON] fails a saving throw, it can choose to succeed instead.",
			group: "Traits"
		},
		{
			label: "Spellcasting (INT)",
			name: "Spellcasting",
			attribute: 'Intelligence',
			desc: "The [MON] is a ???-level spellcaster. Its spellcasting ability is Intelligence (spell save DC [INT SAVE], [INT ATK] to hit with spell attacks). The [MON] has the following ??? spells prepared:\n\n> Cantrips (at will): *spell, spell, spell, spell*\n> 1st level (4 slots): *spell, spell, spell*\n> 2nd level (3 slots): *spell, spell, spell*\n> 3rd level (2 slots): *spell, spell*",
			group: "Traits"
		},
		{
			label: "Spellcasting (WIS)",
			name: "Spellcasting",
			attribute: 'Wisdom',
			desc: "The [MON] is a ???-level spellcaster. Its spellcasting ability is Wisdom (spell save DC [WIS SAVE], [WIS ATK] to hit with spell attacks). The [MON] has the following ??? spells prepared:\n\n> Cantrips (at will): *spell, spell, spell, spell*\n> 1st level (4 slots): *spell, spell, spell*\n> 2nd level (3 slots): *spell, spell, spell*\n> 3rd level (2 slots): *spell, spell*",
			group: "Traits"
		},
		{
			label: "Spellcasting (CHA)",
			name: "Spellcasting",
			attribute: 'Charisma',
			desc: "The [MON] is a ???-level spellcaster. Its spellcasting ability is Charisma (spell save DC [CHA SAVE], [CHA ATK] to hit with spell attacks). The [MON] has the following ??? spells prepared:\n\n> Cantrips (at will): *spell, spell, spell, spell*\n> 1st level (4 slots): *spell, spell, spell*\n> 2nd level (3 slots): *spell, spell, spell*\n> 3rd level (2 slots): *spell, spell*",
			group: "Traits"
		},
		{
			label: "Innate Spellcasting (INT)",
			name: "Innate Spellcasting",
			attribute: 'Intelligence',
			desc: "The [MON]'s innate spellcasting ability is Intelligence (spell save DC [INT SAVE], [INT ATK] to hit with spell attacks). It can innately cast the following spells, requiring no material components:\n\n> At will: *spell, spell, spell*\n> 3/day each: *spell, spell, spell*\n> 1/day each: *spell, spell*",
			group: "Traits"
		},
		{
			label: "Innate Spellcasting (WIS)",
			name: "Innate Spellcasting",
			attribute: 'Wisdom',
			desc: "The [MON]'s innate spellcasting ability is Wisdom (spell save DC [WIS SAVE], [WIS ATK] to hit with spell attacks). It can innately cast the following spells, requiring no material components:\n\n> At will: *spell, spell, spell*\n> 3/day each: *spell, spell, spell*\n> 1/day each: *spell, spell*",
			group: "Traits"
		},
		{
			label: "Innate Spellcasting (CHA)",
			name: "Innate Spellcasting",
			attribute: 'Charisma',
			desc: "The [MON]'s innate spellcasting ability is Charisma (spell save DC [CHA SAVE], [CHA ATK] to hit with spell attacks). It can innately cast the following spells, requiring no material components:\n\n> At will: *spell, spell, spell*\n> 3/day each: *spell, spell, spell*\n> 1/day each: *spell, spell*",
			group: "Traits"
		},
		{
			name: "Ambusher",
			desc: "The [MON] has advantage on attack rolls against any creature it has surprised.",
			group: "Traits"
		},
		{
			name: "Amorphous",
			desc: "The [MON] can move through a space as narrow as 1 inch wide without squeezing.",
			group: "Traits"
		},
		{
			name: "Amphibious",
			desc: "The [MON] can breathe air and water.",
			group: "Traits"
		},
		{
			name: "Angelic Weapons",
			desc: "The [MON]'s weapon attacks are magical. When the [MON] hits with any weapon, the weapon deals an extra [???d???] radiant damage (included in the attack).",
			group: "Traits"
		},
		{
			label: "Animal Telepathy",
			name: "??? Telepathy",
			desc: "The [MON] can magically command any ??? within 120 feet of it, using a limited telepathy.",
			group: "Traits"
		},
		{
			name: "Antimagic Susceptibility",
			desc: "The [MON] is incapacitated while in the area of an antimagic field. If targeted by dispel magic, the [MON] must succeed on a Constitution saving throw against the caster's spell save DC or fall unconscious for 1 minute.",
			group: "Traits"
		},
		{
			name: "Assassinate",
			desc: "During its first turn, the [MON] has advantage on attack rolls against any creature that hasn't taken a turn. Any hit the [MON] scores against a surprised creature is a critical hit.",
			group: "Traits"
		},
		{
			label: "Aversion to Damage",
			name: "Aversion to ???",
			desc: "If the [MON] takes ??? damage, it has disadvantage on attack rolls and ability checks until the end of its next turn.",
			group: "Traits"
		},
		{
			name: "Beast of Burden",
			desc: "The [MON] is considered to be a ??? animal for the purpose of determining its carrying capacity.",
			group: "Traits"
		},
		{
			name: "Berserk",
			desc: "Whenever the [MON] starts its turn with ??? hit points or fewer, roll a d6. On a 6, the [MON] goes berserk. On each of its turns while berserk, the [MON] attacks the nearest creature it can see. If no creature is near enough to move to and attack, the [MON] attacks an object, with preference for an object smaller than itself. Once the [MON] goes berserk, it continues to do so until it is destroyed or regains all its hit points.",
			group: "Traits"
		},
		{
			name: "Blind Senses",
			desc: "The [MON] can't use its blindsight while deafened and unable to smell.",
			group: "Traits"
		},
		{
			name: "Blood Frenzy",
			desc: "The [MON] has advantage on melee attack rolls against any creature that doesn't have all its hit points.",
			group: "Traits"
		},
		{
			name: "Brave",
			desc: "The [MON] has advantage on saving throws against being frightened.",
			group: "Traits"
		},
		{
			name: "Brute",
			desc: "A melee weapon deals one extra die of its damage when the [MON] hits with it (included in the attack).",
			group: "Traits"
		},
		{
			label: "Camouflage",
			name: "??? Camouflage",
			desc: "The [MON] has advantage on Dexterity (Stealth) checks made to hide in ??? terrain.",
			group: "Traits"
		},
		{
			name: "Charge",
			desc: "If the [MON] moves at least ??? ft. straight toward a target and then hits it with a ??? attack on the same turn, the target takes an extra [???d???] ??? damage. If the target is a creature, it must succeed on a DC ??? Strength saving throw or be knocked prone.",
			group: "Traits"
		},
		{
			name: "Chaotic Evil",
			desc: "the [MON] radiates a chaotic and evil aura.",
			group: "Traits"
		},
		{
			label: "Confer Resistance",
			name: "Confer ??? Resistance",
			desc: "The [MON] can grant resistance to ??? damage to anyone riding it.",
			group: "Traits"
		},
		{
			name: "Corrode Metal",
			desc: "Any nonmagical weapon made of metal that hits the [MON] corrodes. After dealing damage, the weapon takes a permanent and cumulative -1 penalty to damage rolls. If its penalty drops to -5, the weapon is destroyed. Non magical ammunition made of metal that hits the [MON] is destroyed after dealing damage.\nThe [MON] can eat through 2-inch-thick, nonmagical metal in 1 round.",
			group: "Traits"
		},
		{
			label: "Damage Absorption",
			name: "??? Absorption",
			desc: "Whenever the [MON] is subjected to ??? damage, it takes no damage and instead regains a number of hit points equal to the ??? damage dealt.",
			group: "Traits"
		},
		{
			name: "Damage Transfer",
			desc: "While it is grappling a creature, the [MON] takes only half the damage dealt to it, and the creature grappled by the [MON] takes the other half.",
			group: "Traits"
		},
		{
			name: "Dark Devotion",
			desc: "The [MON] has advantage on saving throws against being charmed or frightened.",
			group: "Traits"
		},
		{
			name: "Death Burst",
			desc: "When the [MON] dies, it explodes in a burst of ???. Each creature within ??? ft. of it must make a DC ??? Dexterity saving throw, taking [???d???] ??? damage on a failed save, or half as much damage on a successful one.",
			group: "Traits"
		},
		{
			name: "Devil's Sight",
			desc: "Magical darkness doesn't impede the [MON]'s darkvision.",
			group: "Traits"
		},
		{
			name: "Divine Awareness",
			desc: "The [MON] knows if it hears a lie.",
			group: "Traits"
		},
		{
			name: "Duergar Resilience",
			desc: "The [MON] has advantage on saving throws against poison, spells, and illusions, as well as to resist being charmed or paralyzed.",
			group: "Traits"
		},
		{
			name: "Dwarven Resilience",
			desc: "The [MON] has advantage on saving throws against poison, spells, and illusions, as well as to resist being charmed or paralyzed.",
			group: "Traits"
		},
		{
			name: "Earth Glide",
			desc: "The [MON] can burrow through nonmagical, unworked earth and stone. While doing so, the [MON] doesn't disturb the material it moves through.",
			group: "Traits"
		},
		{
			name: "Echolocation",
			desc: "The [MON] can't use its blindsight while deafened.",
			group: "Traits"
		},
		{
			name: "Elemental Demise",
			desc: "If the [MON] dies, its body disintegrates into ???, leaving behind only equipment the [MON] was wearing or carrying.",
			group: "Traits"
		},
		{
			label: "Elemental Form",
			name: "??? Form",
			desc: "The [MON] can enter a hostile creature's space and stop there. It can move through a space as narrow as 1 inch wide without squeezing.",
			group: "Traits"
		},
		{
			name: "Ephemeral",
			desc: "The [MON] can't wear or carry anything.",
			group: "Traits"
		},
		{
			name: "Ethereal Sight",
			desc: "The [MON] can see 60 ft. into the Ethereal Plane when it is on the Material Plane, and vice versa.",
			group: "Traits"
		},
		{
			name: "Evasion",
			desc: "If the [MON] is subjected to an effect that allows it to make a Dexterity saving throw to take only half damage, the [MON] instead takes no damage if it succeeds on the saving throw, and only half damage if it fails.",
			group: "Traits"
		},
		{
			name: "Evil",
			desc: "the [MON] radiates an evil aura.",
			group: "Traits"
		},
		{
			name: "False Appearance",
			desc: "While the [MON] remains motionless, it is indistinguishable from ???.",
			group: "Traits"
		},
		{
			name: "Fear Aura",
			desc: "Any creature hostile to the [MON] that starts its turn within ??? feet of the [MON] must make a DC ??? Wisdom saving throw, unless the [MON] is incapacitated. On a failed save, the creature is frightened until the start of its next turn. If a creature's saving throw is successful, the creature is immune to the [MON]'s Fear Aura for the next 24 hours.",
			group: "Traits"
		},
		{
			name: "Fey Ancestry",
			desc: "The [MON] has advantage on saving throws against being charmed, and magic can't put the [MON] to sleep.",
			group: "Traits"
		},
		{
			name: "Flyby",
			desc: "The [MON] doesn't provoke opportunity attacks when it flies out of an enemy's reach.",
			group: "Traits"
		},
		{
			name: "Freedom of Movement",
			desc: "The [MON] ignores difficult terrain, and magical effects can't reduce its speed or cause it to be restrained. It can spend 5 feet of movement to escape from nonmagical restraints or being grappled.",
			group: "Traits"
		},
		{
			name: "Gnome Cunning",
			desc: "The [MON] has advantage on Intelligence, Wisdom, and Charisma saving throws against magic.",
			group: "Traits"
		},
		{
			name: "Grappler",
			desc: "The [MON] has advantage on attack rolls against any creature grappled by it.",
			group: "Traits"
		},
		{
			name: "Halfling Nimbleness",
			desc: "The [MON] can move through the space of any creature that is of a size larger than its own.",
			group: "Traits"
		},
		{
			name: "Heated Body",
			desc: "A creature that touches the [MON] or hits it with a melee attack while within ??? feet of it takes [???d???] fire damage.",
			group: "Traits"
		},
		{
			name: "Heated Weapons",
			desc: "Any metal melee weapon the [MON] wields deals an extra [???d???] fire damage on a hit (included in the attack).",
			group: "Traits"
		},
		{
			name: "Hellish Weapons",
			desc: "The [MON]'s weapon attacks are magical and deal an extra [???d???] poison damage on a hit (included in the attacks).",
			group: "Traits"
		},
		{
			name: "Hold Breath",
			desc: "The [MON] can hold its breath for ???.",
			group: "Traits"
		},
		{
			name: "Ice Walk",
			desc: "The [MON] can move across and climb icy surfaces without needing to make an ability check. Additionally, difficult terrain composed of ice or snow doesn't cost it extra movement.",
			group: "Traits"
		},
		{
			name: "Illumination",
			desc: "The [MON] sheds bright light in a ???-foot radius and dim light in an additional ??? ft.",
			group: "Traits"
		},
		{
			name: "Immutable Form",
			desc: "The [MON] is immune to any spell or effect that would alter its form.",
			group: "Traits"
		},
		{
			name: "Incorporeal",
			desc: "The [MON] can move through other creatures and objects as if they were difficult terrain. It takes [???d???] force damage if it ends its turn inside an object.",
			group: "Traits"
		},
		{
			name: "Inscrutable",
			desc: "The [MON] is immune to any effect that would sense its emotions or read its thoughts, as well as any divination spell that it refuses. Wisdom (Insight) checks made to ascertain the [MON]'s intentions or sincerity have disadvantage.",
			group: "Traits"
		},
		{
			label: "Invisibility (Permanent)",
			name: "Invisibility",
			desc: "The [MON] is invisible.",
			group: "Traits"
		},
		{
			name: "Keen Hearing",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on hearing.",
			group: "Traits"
		},
		{
			name: "Keen Sight",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on sight.",
			group: "Traits"
		},
		{
			name: "Keen Smell",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on smell.",
			group: "Traits"
		},
		{
			name: "Keen Hearing and Sight",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on hearing or sight.",
			group: "Traits"
		},
		{
			name: "Keen Hearing and Smell",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on hearing or smell.",
			group: "Traits"
		},
		{
			name: "Keen Sight and Smell",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on sight or smell.",
			group: "Traits"
		},
		{
			name: "Keen Senses",
			desc: "The [MON] has advantage on Wisdom (Perception) checks that rely on sight, smell or hearing.",
			group: "Traits"
		},
		{
			name: "Lawful Evil",
			desc: "the [MON] radiates a lawful and evil aura.",
			group: "Traits"
		},
		{
			name: "Labyrinthine Recall",
			desc: "The [MON] can perfectly recall any path it has traveled.",
			group: "Traits"
		},
		{
			name: "Light Sensitivity",
			desc: "While in bright light, the [MON] has disadvantage on attack rolls, as well as on wisdom (perception) checks that rely on sight.",
			group: "Traits"
		},
		{
			name: "Limited Amphibiousness",
			desc: "The [MON] can breathe air and water, but it needs to be submerged at least once every 4 hours to avoid suffocating.",
			group: "Traits"
		},
		{
			name: "Limited Magic Immunity",
			desc: "The [MON] can't be affected or detected by spells of ??? level or lower unless it wishes to be. It has advantage on saving throws against all other spells and magical effects.",
			group: "Traits"
		},
		{
			name: "Limited Telepathy",
			desc: "The [MON] can magically communicate simple ideas, emotions, and images telepathically with any creature within ??? ft. of it.",
			group: "Traits"
		},
		{
			name: "Lucky",
			desc: "When the [MON] rolls a 1 on the d20 for an attack roll, ability check, or saving throw, it can reroll the die and must use the new roll.",
			group: "Traits"
		},
		{
			name: "Magic Resistance",
			desc: "The [MON] has advantage on saving throws against spells and other magical effects.",
			group: "Traits"
		},
		{
			name: "Magic Weapons",
			desc: "The [MON]'s weapon attacks are magical.",
			group: "Traits"
		},
		{
			name: "Martial Advantage",
			desc: "Once per turn, the [MON] can deal an extra [???d???] damage to a creature it hits with a weapon attack if that creature is within 5 ft. of an ally of the [MON] that isn't incapacitated.",
			group: "Traits"
		},
		{
			name: "Mimicry",
			desc: "The [MON] can mimic ??? sounds it has heard. A creature that hears the sounds can tell they are imitations with a successful DC ??? Wisdom (Insight) check.",
			group: "Traits"
		},
		{
			name: "Naturally Stealthy",
			desc: "The [MON] can attempt to hide even when it is obscured only by a creature that is at least one size larger than itself.",
			group: "Traits"
		},
		{
			name: "Pack Tactics",
			desc: "The [MON] has advantage on an attack roll against a creature if at least one of the [MON]'s allies is within 5 ft. of the creature and the ally isn't incapacitated.",
			group: "Traits"
		},
		{
			name: "Petrifying Gaze",
			desc: "If a creature starts its turn within ??? ft. of the [MON] and the two of them can see each other, the [MON] can force the creature to make a DC ??? Constitution saving throw if the [MON] isn't incapacitated. On a failed save, the creature magically begins to turn to stone and is restrained. It must repeat the saving throw at the end of its next turn. On a success, the effect ends. On a failure, the creature is petrified until freed by the greater restoration spell or other magic.\nA creature that isn't surprised can avert its eyes to avoid the saving throw at the start of its turn. If it does so, it can't see the [MON] until the start of its next turn, when it can avert its eyes again. If it looks at the [MON] in the meantime, it must immediately make the save.\nIf the [MON] sees its reflection within ??? ft. of it in bright light, it is affected by its own gaze.",
			group: "Traits"
		},
		{
			name: "Pounce",
			desc: "If the [MON] moves at least ??? ft. straight toward a target and then hits it with a ??? attack on the same turn, the target takes an extra [???d???] ??? damage. If the target is a creature, it must succeed on a DC ??? Strength saving throw or be knocked prone. If the target is prone, the [MON] can make another ??? attack against it as a bonus action.",
			group: "Traits"
		},
		{
			name: "Reactive",
			desc: "The [MON] can take one reaction on every turn in combat.",
			group: "Traits"
		},
		{
			name: "Reckless",
			desc: "At the start of its turn, the [MON] can gain advantage on all melee weapon attack rolls it makes during that turn, but attack rolls against it have advantage until the start of its next turn.",
			group: "Traits"
		},
		{
			name: "Regeneration",
			desc: "The [MON] regains ??? hit points at the start of its turn if it has at least 1 hit point.",
			group: "Traits"
		},
		{
			label: "Regeneration (Troll)",
			name: "Regeneration",
			desc: "The [MON] regains ??? hit points at the start of its turn. If the [MON] takes acid or fire damage, this trait doesn't function at the start of the [MON]'s next turn. The [MON] dies only if it starts its turn with 0 hit points and doesn't regenerate.",
			group: "Traits"
		},
		{
			label: "Relentless",
			name: "Relentless (Recharges after a Short or Long Rest)",
			desc: "If the [MON] takes ??? damage or less that would reduce it to 0 hit points, it is reduced to 1 hit point instead.",
			group: "Traits"
		},
		{
			name: "Rust Metal",
			desc: "Any nonmagical weapon made of metal that hits the [MON] corrodes. After dealing damage, the weapon takes a permanent and cumulative -1 penalty to damage rolls. If its penalty drops to -5, the weapon is destroyed. Non magical ammunition made of metal that hits the [MON] is destroyed after dealing damage.",
			group: "Traits"
		},
		{
			name: "Savage Attacks",
			desc: "When the [MON] scores a critical hit with a melee weapon attack, it can roll one of the weapon’s damage dice one additional time and add it to the extra damage of the critical hit.",
			group: "Traits"
		},
		{
			name: "Sea Legs",
			desc: "The [MON] has advantage on ability checks and saving throws to resist being knocked prone.",
			group: "Traits"
		},
		{
			name: "Sense Magic",
			desc: "The [MON] senses magic within 120 feet of it at will. This trait otherwise works like the detect magic spell but isn't itself magical.",
			group: "Traits"
		},
		{
			name: "Shielded Mind",
			desc: "The [MON] is immune to scrying and to any effect that would sense its emotions, read its thoughts, or detect its location.",
			group: "Traits"
		},
		{
			name: "Siege Monster",
			desc: "The [MON] deals double damage to objects and structures.",
			group: "Traits"
		},
		{
			name: "Slippery",
			desc: "The [MON] has advantage on ability checks and saving throws made to escape a grapple.",
			group: "Traits"
		},
		{
			label: "Sneak Attack",
			name: "Sneak Attack (1/Turn)",
			desc: "The [MON] deals an extra [???d???] damage when it hits a target with a weapon attack and has advantage on the attack roll, or when the target is within 5 ft. of an ally of the [MON] that isn't incapacitated and the [MON] doesn't have disadvantage on the attack roll.",
			group: "Traits"
		},
		{
			name: "Speak With Plants and Beasts",
			desc: "The [MON] can communicate with beasts and plants as if they shared a language.",
			group: "Traits"
		},
		{
			name: "Spider Climb",
			desc: "The [MON] can climb difficult surfaces, including upside down on ceilings, without needing to make an ability check.",
			group: "Traits"
		},
		{
			name: "Standing Leap",
			desc: "The [MON]'s long jump is up to ??? ft. and its high jump is up to ??? ft., with or without a running start.",
			group: "Traits"
		},
		{
			name: "Steadfast",
			desc: "The [MON] can't be frightened while it can see an allied creature within 30 feet of it.",
			group: "Traits"
		},
		{
			name: "Sunlight Sensitivity",
			desc: "While in sunlight, the [MON] has disadvantage on attack rolls, as well as on Wisdom (Perception) checks that rely on sight.",
			group: "Traits"
		},
		{
			name: "Sunlight Weakness",
			desc: "While in sunlight, the [MON] has disadvantage on attack rolls, ability checks, and saving throws.",
			group: "Traits"
		},
		{
			name: "Sure-Footed",
			desc: "The [MON] has advantage on Strength and Dexterity saving throws made against effects that would knock it prone.",
			group: "Traits"
		},
		{
			name: "Surprise Attack",
			desc: "If the [MON] surprises a creature and hits it with an attack during the first round of combat, the target takes an extra [???d???] damage from the attack.",
			group: "Traits"
		},
		{
			name: "Swarm",
			desc: "The swarm can occupy another creature's space and vice versa, and the swarm can move through any opening large enough for a ???. The swarm can't regain hit points or gain temporary hit points.",
			group: "Traits"
		},
		{
			name: "Trampling Charge",
			desc: "If the [MON] moves at least ??? ft. straight toward a target and then hits it with a ??? attack on the same turn, the target takes an extra [???d???] ??? damage. If the target is a creature, it must succeed on a DC ??? Strength saving throw or be knocked prone. If the target is prone, the [MON] can make another ??? attack against it as a bonus action.",
			group: "Traits"
		},
		{
			name: "Tunneler",
			desc: "The [MON] can burrow through solid rock at half its burrow speed and leaves a ???-foot-diameter tunnel in its wake.",
			group: "Traits"
		},
		{
			name: "Turn Resistance",
			desc: "The [MON] has advantage on saving throws against any effect that turns undead.",
			group: "Traits"
		},
		{
			name: "Two-Headed",
			desc: "The [MON] has advantage on Wisdom (Perception) checks and on saving throws against being blinded, charmed, deafened, frightened, stunned, and knocked unconscious.",
			group: "Traits"
		},
		{
			name: "Undead Fortitude",
			desc: "If damage reduces the [MON] to 0 hit points, it must make a Constitution saving throw with a DC of 5 + the damage taken, unless the damage is radiant or from a critical hit. On a success, the [MON] drops to 1 hit point instead.",
			group: "Traits"
		},
		{
			name: "Water Breathing",
			desc: "The [MON] can breathe only underwater.",
			group: "Traits"
		},
		{
			name: "Web Sense",
			desc: "While in contact with a web, the [MON] knows the exact location of any other creature in contact with the same web.",
			group: "Traits"
		},
		{
			name: "Web Walker",
			desc: "The [MON] ignores movement restrictions caused by webbing.",
			group: "Traits"
		},
	];
	static reactions: Ability[] = [
		{
			name: "Parry",
			desc: "The [MON] adds [PB] to its AC against one melee attack that would hit it. To do so, the [MON] must see the attacker and be wielding a melee weapon.",
			group: "Reactions"
		},
		{
			name: "Split",
			desc: "When a [MON] that is Medium or larger is subjected to lightning or slashing damage, it splits into two new [MONS] if it has at least 10 hit points. Each new [MON] has hit points equal to half the original [MON]'s, rounded down. New [MONS] are one size smaller than the original [MON].",
			group: "Reactions"
		},
		{
			name: "Tail Attack",
			desc: "When a creature the [MON] can see within 10 feet hits the [MON] with a melee attack, the [MON] makes a tail attack against it.",
			group: "Reactions"
		},
	]

	static bonus_actions: Ability[] = [
		{
			name: "A Call to Arms",
			desc: "Once per encounter, as a bonus action, the [MON] can sound the alarm calling an additional 1d4 ??? to his side in 1d3 rounds.",
			group: "Bonus Actions"
		},
		{
			name: "Aggressive",
			desc: "As a bonus action, the [MON] can move up to its speed toward a hostile creature that it can see.",
			group: "Bonus Actions"
		},
		{
			name: "Butt Strike",
			desc: "When the [MON] takes the attack action with its polearm, it may make a melee attack with the butt of its polearm as a bonus action. *Melee Attack*: [STR ATK] to hit, reach same as polearm, one target. *Hit:* [STR 1D4] bludgeoning damage.",
			group: "Bonus Actions"
		},
		{
			name: "Cunning Action",
			desc: "On each of its turns, the [MON] can use a bonus action to take the Dash, Disengage, or Hide action.",
			group: "Bonus Actions"
		},
		{
			name: "Divine Eminence",
			desc: "As a bonus action, the [MON] can expend a spell slot to cause its melee weapon attacks to magically deal an extra [???d???] radiant damage to a target on a hit. This benefit lasts until the end of the turn. If the [MON] expends a spell slot of 2nd level or higher, the extra damage increases by 1d6 for each level above 1st.",
			group: "Bonus Actions"
		},
		{
			name: "Ethereal Jaunt",
			desc: "As a bonus action, the [MON] can magically shift from the Material Plane to the Ethereal Plane, or vice versa.",
			group: "Bonus Actions"
		},
		{
			name: "Misty Step",
			desc: "The [MON] teleports to an unoccupied space they can see within 30 feet.",
			group: "Bonus Actions"
		},
		{
			name: "Nimble Escape",
			desc: "The [MON] can take the Disengage or Hide action as a bonus action on each of its turns.",
			group: "Bonus Actions"
		},
		{
			name: "Rampage",
			desc: "When the [MON] reduces a creature to 0 hit points with a melee attack on its turn, the [MON] can take a bonus action to move up to half its speed and make a ??? attack.",
			group: "Bonus Actions"
		},
		{
			name: "Shadow Stealth",
			desc: "While in dim light or darkness, the [MON] can take the Hide action as a bonus action.",
			group: "Bonus Actions"
		},
		{
			name: "Shield Bash",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one creature. *Hit:* [STR 1d4] bludgeoning damage. If the target is a Medium or smaller creature, it must succeed on a DC [STR SAVE] Strength saving throw or be knocked prone.",
			group: "Bonus Actions"
		},
	];

	static legendary_actions: Ability[] = [
		{
			label: "Attack",
			name: "??? Attack",
			desc: "The [MON] makes a ??? attack.",
			group: "Legendary Actions"
		},
		{
			name: "Detect",
			desc: "The [MON] makes a Wisdom (Perception) check.",
			group: "Legendary Actions"
		},
		{
			name: "Teleport",
			desc: "The [MON] magically teleports, along with any equipment it is wearing or carrying, up to 120 feet to an unoccupied space it can see.",
			group: "Legendary Actions"
		},
		{
			label: "Wing Attack",
			name: "Wing Attack (Costs 2 Actions)",
			desc: "The [MON] beats its wings. Each creature within ??? ft. of the [MON] must succeed on a DC ??? Dexterity saving throw or take [STR ???d???] bludgeoning damage and be knocked prone. The [MON] can then fly up to half its flying speed.",
			group: "Legendary Actions"
		},
	];

	static weapons: Ability[] = [
		{
			name: "Battleaxe",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] slashing damage, or [STR 1D10] slashing damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Blowgun",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 25/100 ft., one target. *Hit:* [DEX 1] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Club",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D4] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			label: "Dagger (STR)",
			name: "Dagger",
			attribute: 'Strength',
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Dagger (DEX)",
			name: "Dagger",
			attribute: 'Dexterity',
			desc: "*Melee or Ranged Weapon Attack:* [DEX ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [DEX 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Dart (STR)",
			name: "Dart",
			attribute: 'Strength',
			desc: "*Ranged Weapon Attack:* [STR ATK] to hit, range 20/60 ft., one target. *Hit:* [STR 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Dart (DEX)",
			name: "Dart",
			attribute: 'Dexterity',
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 20/60 ft., one target. *Hit:* [DEX 1D4] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			name: "Flail",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Glaive",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D10] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Greataxe",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D12] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Greatclub",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Greatsword",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 2D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Halberd",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D10] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Handaxe",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Hand Crossbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 30/120 ft., one target. *Hit:* [DEX 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Heavy Crossbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 100/400 ft., one target. *Hit:* [DEX 1D10] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			name: "Javelin",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 30/120 ft., one target. *Hit:* [STR 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Lance",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D12] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Light Crossbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 80/320 ft., one target. *Hit:* [DEX 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			name: "Light Hammer",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D4] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Longbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 150/600 ft., one target. *Hit:* [DEX 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			name: "Longsword",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] slashing damage, or [STR 1D10] slashing damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Mace",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Maul",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 2D6] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Morningstar",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Net",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 5/15 ft., one Large or smaller creature. *Hit:* The target is restrained. A creature can use its action to make a DC 10 Strength check to free itself or another creature in a net, ending the effect on a success. Dealing 5 slashing damage to the net (AC 10) frees the target without harming it and destroys the net.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Pike",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D10] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: true,
               range: 'melee',
			   handed: 'two',
			   attribute: 'str'
			}
		},
		{
			name: "Quarterstaff",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] bludgeoning damage, or [STR 1D8] bludgeoning damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			label: "Rapier (STR)",
			name: "Rapier",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Rapier (DEX)",
			name: "Rapier",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Scimitar (STR)",
			name: "Scimitar",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Scimitar (DEX)",
			name: "Scimitar",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX 1D6] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			name: "Shortbow",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 80/320 ft., one target. *Hit:* [DEX 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'two',
			   attribute: 'dex'
			}
		},
		{
			label: "Shortsword (STR)",
			name: "Shortsword",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Shortsword (DEX)",
			name: "Shortsword",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX 1D6] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			name: "Sickle",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D4] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Sling",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range 30/120 ft., one target. *Hit:* [DEX 1D4] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'ranged',
			   handed: 'one',
			   attribute: 'dex'
			}
		},
		{
			name: "Spear",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D6] piercing damage, or [STR 1D8] piercing damage if used with two hands to make a melee attack.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'both',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Trident",
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach 5 ft. or range 20/60 ft., one target. *Hit:* [STR 1D6] piercing damage, or [STR 1D8] piercing damage if used with two hands to make a melee attack.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'both',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "Unarmed Strike",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1] bludgeoning damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: true,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			name: "Warhammer",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] bludgeoning damage, or [STR 1D10] bludgeoning damage if used with two hands.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'versatile',
			   attribute: 'str'
			}
		},
		{
			name: "War Pick",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1D8] piercing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'str'
			}
		},
		{
			label: "Whip (STR)",
			name: "Whip",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 10 ft., one target. *Hit:* [STR 1D4] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		},
		{
			label: "Whip (DEX)",
			name: "Whip",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 10 ft., one target. *Hit:* [DEX 1D4] slashing damage.",
			group: "Weapon Attacks",
			weapon_data: {
               simple: false,
			   heavy: false,
               range: 'melee',
			   handed: 'one',
			   attribute: 'finese'
			}
		}
	];

	static getGearNames(): string[] {
        return [...new Set(this.weapons.map(weapon => weapon.name))];
    }
	static getMagicGearNames(): string[] {
        return [...new Set(this.magic_items.map(item => item.name))];
    }

	static actions = [...this.base_actions, ...this.weapons];

	static magic_items: Ability[] = [];
  
	static getOptions(blockType: string): Ability[] {
	  if (blockType === 'actions')           return this.actions;
	  if (blockType === 'legendary_actions') return this.legendary_actions;
	  if (blockType === 'bonus_actions')     return this.bonus_actions;
	  if (blockType === 'reactions')         return this.reactions;
	  if (blockType === 'traits')            return this.traits;
	  if (blockType === 'inventory')         return this.magic_items;
	  return [];
	}

	static setMagicItems(magicItems: any[], documents: Map<string, { name: string; licenses: string[]; }>): void {
		const docMap = new Map<string, { name: string; order: number }>();
		let index = 0;
		documents.forEach((licenses, key, map) => {
		  docMap.set(key, { name: licenses.name, order: index++ });
		});
	
		magicItems.forEach(mi => {
		  const doc = docMap.get(mi.document__slug);
		  if (doc) {
			mi.label = mi.name;
			mi.group = doc.name;
			mi.groupOrder = doc.order;
		  }
		});
	
		this.magic_items = magicItems.sort((m1: Ability, m2: Ability) => {
		  if (m1.groupOrder! < m2.groupOrder!) return -1;
		  if (m1.groupOrder! > m2.groupOrder!) return 1;
		  return (m1.label ?? m1.name).localeCompare(m2.label ?? m2.name);
		});
	  }

	/*
      [MON]: Shows the monster's name.
      [MONS]: Shows the monster's plural name.
      [CHA]: Shows the monster's charisma modifier.
      [PB]: Shows the monster's proficiency bonus.
      [3D6]: Computes 3d6.
      [STR ATK]: Calculates the modifier to the monster's attack roll for a strength-based attack.
      [DEX 2D8]: Calculates the damage roll for a dexterity-based attack with damage dice 2d8.
      [WIS SAVE]: Calculates the save DC vs the monster's wisdom.
      [3D6 + 1], [STR ATK - 2], [WIS SAVE + 3], [PB + 2]: Adds a modifier to the given values.
    */
static ReplaceTags(desc: string, mon: Monster): string {
    const bracketExp = /\[(.*?)\]/g;
    const matches: RegExpExecArray[] = [];
    let match;

    while ((match = bracketExp.exec(desc)) != null) {
      matches.push(match);
    }

	// We use reduceRight because by starting from the last match and moving towards the first,
	// we ensure that replacing a match does not affect the indices of the remaining matches.
	// This is crucial because string replacement can alter the length of the string, 
	// which could invalidate the indices of subsequent matches if they were calculated beforehand.
	return matches.reduceRight((currentDesc, match) => {
      let readString = Abilities.parseReadString(match[1]);
      if (!readString) {
        return currentDesc;
      }
      if (readString === "mon") {
        return Abilities.replaceMatch(currentDesc, match, (mon.shortName || mon.name).toLowerCase());
      }
      if (readString === "mons") {
        return Abilities.replaceMatch(currentDesc, match, (mon.pluralName || mon.name).toLowerCase());
      }
	  const capitalize = (str: string): string => {
		return str[0].toUpperCase() + str.substring(1).toLowerCase();
	  }
      if (readString === "Mon") {
        return Abilities.replaceMatch(currentDesc, match, capitalize(mon.shortName || mon.name));
      }
      if (readString === "Mons") {
        return Abilities.replaceMatch(currentDesc, match, capitalize(mon.pluralName || mon.name));
      }
	  readString = readString.toLowerCase();
      if (readString === "mon") {
        return Abilities.replaceMatch(currentDesc, match, (mon.shortName || mon.name));
      }
      if (readString === "mons") {
        return Abilities.replaceMatch(currentDesc, match, (mon.pluralName || mon.name));
      }
	  //if (readString === "pb") {
      //  return Abilities.replaceMatch(currentDesc, match, mon.proficiencyBonus);
      //}
      return Abilities.processCustomDescriptor(currentDesc, match, readString, mon);
    }, desc);
  }

  static parseReadString(str: string): string {
    return str.replace(/ +/g, ' ').trim();
  }

  static replaceMatch(desc: string, match: RegExpExecArray, replacement: string): string {
    return desc.slice(0, match.index) + replacement + desc.slice(match.index + match[0].length);
  }

  static GetAttributeBonus(stat: string, mon: Monster): number | null {
	const attrName = Attributes.getAttrName(stat);
	if (attrName != '') {
		const attrLevel = mon.attributes[attrName]; // Assert the type
		return Attributes.getBonus(attrLevel);
	}
	return null;
  }
  
  static processCustomDescriptor(desc: string, match: RegExpExecArray, readString: string, mon: Monster): string {
    const damageExp = /(\d*)d(\d+)/;
    const bonusExp = /^[+-] ?(\d+)$/;

    if (readString.length == 0) {
      return desc;
    }

    let readPosition = 0;
    let type: string | null = null;
    let attrBonus: number | null = 0;
	if (readString.startsWith('pb')) {
		attrBonus = mon.proficiencyBonus;
		type = 'pb';
		readPosition = 2;
	} else if (readString.startsWith('prof')) {
		attrBonus = mon.proficiencyBonus;
		type = 'pb';
		readPosition = 4;
	} else {
		attrBonus = Abilities.GetAttributeBonus(readString.substring(0, 3), mon);
	}
    let bonus = 0;

    if (attrBonus != null && !isNaN(attrBonus)) {
      bonus = attrBonus;
      readPosition = readPosition || 3;
      type = type || 'stat';
      if ((readString.length > 3) && (readString !== 'pb')) {
        if (readString.substring(3, 7).toLowerCase() === ' atk') {
          bonus += mon.proficiencyBonus;
          readPosition = 7;
          type = 'atk';
        } else if (readString.substring(3, 8).toLowerCase() === ' save') {
          bonus += mon.proficiencyBonus + 8;
          readPosition = 8;
          type = 'save';
        }
      }

      if (readPosition < readString.length) {
        while (readString[readPosition] === ' ') readPosition++;
      }
    }

    let rollDice: number | null = null;
    let rollDieType: number | null = null;
    if ((type == null || type === 'stat' || type === 'pb') && readPosition < readString.length) {
      const nextToken = readString.substring(readPosition).replace(/ +/g, '');

      const damageMatch = damageExp.exec(nextToken);
      if (damageMatch != null) {
        rollDice = damageMatch[1] ? parseInt(damageMatch[1]) : 1;
        rollDieType = parseInt(damageMatch[2]);
        readPosition += damageMatch[0].length;
        type = 'dmg';

        if ((readPosition < readString.length) && (readString[readPosition] === ' ')) {
          readPosition++;
        }
      } else {
		try {
			const tokenInt = parseInt(nextToken.trim());
			if (nextToken.trim() === ('' + tokenInt)) {
				// this is a pure number, like [str 1] for an unarmed strike:
				rollDieType = 1;
				readPosition += nextToken.length;
				type = 'dmg';
			}
		} catch (error) {
			console.log('error parsing int ' + nextToken);
			type = 'error';
		}
	  }
    }

    if (type != 'error' && readPosition < readString.length) {
      const nextToken = readString.substring(readPosition);
      const bonusMatch = nextToken.match(bonusExp);
      if (bonusMatch) {
        bonus += nextToken[0] === '-' ? -parseInt(bonusMatch[1]) : parseInt(bonusMatch[1]);
      } else {
        type = 'error';
      }
    }

    if (type == null || type === 'error') {
      return desc;
    }

    let results: string = desc;
    switch (type) {
	  case 'pb':
		  results = '' + bonus;
		  break;
      case 'stat':
      case 'atk':
        results = ((bonus >= 0) ? '+': '') + bonus;
        break;
      case 'save':
        results = bonus.toString();
        break;
      case 'dmg':
		if (rollDieType === 1) {
			results = ((rollDice || 1) + bonus) + ' (' + (rollDice || 1);
		} else {
			results = Math.max(Math.floor((rollDice || 1) * ((rollDieType! + 1) / 2) + bonus), 1) +
				' (' + (rollDice || 1) + 'd' + rollDieType;
		}
		results += ((bonus > 0) ? ' + ' + bonus : 
				   ((bonus < 0) ? ' - ' + -bonus : '')) + ')';
        break;
    }
    return Abilities.replaceMatch(desc, match, results);
  }
}

export default Abilities;